/**
 * Created by tayloremolo on 11/4/17.
 */
import React, {Component} from 'react';
import ReactDOM from "react-dom";

class RealSection extends Component {
    // constructor() {
    //     super();
    //
    // }
    // componentDidMount(){
    //     });
    // }

    render() {

        return (
            <div>
                <div className="section-6-et block-2 z-14">
                    <div className="container relative-text pb-40">
                        <div className="row pb-40">
                            <div className="col s12 center-align">
                                <img className="responsive-img" src="../static/Mastermind-text-1-to-BG-6.png" alt="This is real entrepreneurship"/>
                            </div>
                            <div className="col s12 center-align">
                                <p className="f-18 bold-text white-text">Take Ownership is a motivating, impactful, pure value mastermind with like-minded entrepreneurs from around the globe.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }

}

export default RealSection;


// WEBPACK FOOTER //
// ./src/components/real-section.js